import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "grid w-full grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-7" }
const _hoisted_3 = { class: "hidden w-full mt-auto text-right lg:block" }

import BookingLayout from '@/layouts/BookingLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import BranchCard from '@/components/cards/BranchCard.vue';
import ComingSoonBranchCard from '@/components/cards/ComingSoonBranchCard.vue';
// import { CheckIcon } from "@heroicons/vue/24/solid";

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import Storage from '@/helpers/storage';

import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';

import booking from "@/classes/Booking";
import { useBookingStore } from '@/store/booking';

// Router Instance

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingPage',
  setup(__props) {

const router = useRouter();

// State Instance
const bookingStoreState = useBookingStore();

// Local Storage Instance
const bookingLocalStorage = new Storage();
const bookingLocalStoragePayload = ref(JSON.parse(bookingLocalStorage.get('bookingPayload')));
const bookingLocalStorageSummary = ref(JSON.parse(bookingLocalStorage.get('bookingSummary')));
const patientDataLocalStorage = ref(JSON.parse(bookingLocalStorage.get('patient')));

// Data
const loader = ref(false);
const showError = ref(false);
const errorMsg = ref(null);
const selectedBranchId = ref();
const branches = ref();

// Methods
const fetchBranches = () => {
    loader.value = true;

    booking.getBranches()
        .then((result: any) => {
            loader.value = false;
            branches.value = result.data.response;            
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const fetchDrafts = () => {
    bookingStoreState.bookingPayload = bookingLocalStoragePayload.value || bookingStoreState.bookingPayload;
    bookingStoreState.bookingSummary = bookingLocalStorageSummary.value || bookingStoreState.bookingSummary;
    
    bookingStoreState.bookingPayload.patient_id = patientDataLocalStorage.value.patient_id;
    selectedBranchId.value = bookingStoreState.bookingPayload.branch_id;
}

const saveDrafts = () => {
    bookingLocalStorage.set('bookingPayload', JSON.stringify(bookingStoreState.bookingPayload));
    bookingLocalStorage.set('bookingSummary', JSON.stringify(bookingStoreState.bookingSummary));
}

const selectedBranch = (branchId: any) =>  {
    const filteredBranch = branches.value.find(x => x.id == branchId);

    bookingStoreState.bookingPayload.branch_id = filteredBranch.id;
    bookingStoreState.bookingPayload.branch_name = filteredBranch.name;
    bookingStoreState.bookingPayload.branch_address = filteredBranch.address_line;
    bookingStoreState.bookingSummary.selectedBranch = filteredBranch.name;

    selectedBranchId.value = bookingStoreState.bookingPayload.branch_id;

}

const proceed = () => {
    if(selectedBranchId.value) {
        saveDrafts();
        router.push('/booking/choose-package');
    }
}

onMounted( () => {
    fetchBranches();
    fetchDrafts();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BookingLayout, {
    step: "1",
    selected: selectedBranchId.value,
    onProceed: proceed
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branches.value, (item, index) => {
            return (_openBlock(), _createBlock(BranchCard, {
              key: index,
              item: item,
              selectedBranchId: selectedBranchId.value,
              onClick: _withModifiers(($event: any) => (selectedBranch(item.id)), ["prevent"])
            }, null, 8, ["item", "selectedBranchId", "onClick"]))
          }), 128)),
          _createVNode(ComingSoonBranchCard)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ButtonComponent, {
            disabled: !selectedBranchId.value,
            text: "Continue",
            onClick: _withModifiers(proceed, ["prevent"])
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["selected"]))
}
}

})